import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom/client'; // ✅ updated import
import Root from './components/root/Root';

const container = document.getElementById('root');

if (container) {
	const root = ReactDOM.createRoot(container); // ✅ new React 18 API
	root.render(
		<React.StrictMode>
			<Root />
		</React.StrictMode>
	);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
